import { render, staticRenderFns } from "./MemberConfig.vue?vue&type=template&id=3e867d4a"
import script from "./MemberConfig.vue?vue&type=script&lang=js"
export * from "./MemberConfig.vue?vue&type=script&lang=js"
import style0 from "./MemberConfig.vue?vue&type=style&index=0&id=3e867d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports